import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";

const GlobalStyles = makeStyles((theme: Theme) =>
  createStyles({
    rightsideMenu: {
      "& .MuiPaper-root": {
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[700] : "#eceeef",
      },
      "& .MuiTypography-root": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .MuiListItem-root": {
        cursor: "pointer",
      },
    },
    onboardingDatagridContainer: {
      height: "Calc(100vh - 310px)",
      width: "inherit",
      minHeight: "550px",
      marginBottom: theme.spacing(2),
    },
    checkBoxLabel: {
      transform: "translate(0, 1.5px) scale(0.75)",
      transformOrigin: "top left",
    },
    formikContainer: {
      "& .MuiFormHelperText-root": {
        fontSize: "0.8em",
      },
      "& .MuiFormControl-root": {
        fontSize: "20px",
      },
      "& .MuiInput-root": {
        "&::before": {
          borderBottomColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.grey[500],
          borderBottomStyle: 'solid',
        }
      },
      "& .MuiInputBase-input": {
        marginTop: theme.spacing(1),
      },
      "& .MuiSwitch-root": {
        marginLeft: '2px',
      },
      "& .MuiFormLabel-root": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        minHeight: "30px !important",
        width: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
      },
      "& MuiTypography-root": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        minHeight: "30px !important",
      },
      "& .MuiAlert-root": {
        borderRadius: 0,
      },
      "& .MuiTreeItem-content": {
        marginBottom: '5px',
      },
      "& .MuiAlert-outlinedWarning": {
        borderLeftWidth: "5px",
      },
      "& .MuiAlert-outlinedError": {
        borderLeftWidth: "5px",
      },
      "& .MuiAlert-outlinedInfo": {
        borderLeftWidth: "5px",
      },
      "& .MuiFormLabel-root.Mui-disabled": {
        color: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.54)" : "rgba(0, 0, 0, 0.54)",
      }
    },
    dialogContainer: {
      "& .MuiDialogContent-dividers": {
        borderTopColor: "transparent",
      },
    },
    datagridRoot: {
      transform: 'translateX(-100%)',
      animation: "slideIn 1s forwards",
      height: "inherit",
      minHeight: '550px',
      borderColor: "transparent",
      borderWidth: 0,
      [theme.breakpoints.down("xs")]: {
        minHeight: "400px",
      },
      "& .error": {
        backgroundColor: "#f5dada",
      },
      "& .success": {
        backgroundColor: "#e7fcde",
      },
      "& .MuiDataGrid-root": {
        borderColor: "transparent !important",
        borderWidth: 1,
        color: theme.palette.type === "dark" ? theme.palette.grey[50] : theme.palette.grey[900],
      },
      "& .MuiDataGrid-columnsContainer": {
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[50],
      },
      "& .MuiTablePagination-toolbar": {
        color: theme.palette.type === "dark" ? theme.palette.grey[300] : theme.palette.grey[700],
        marginTop: theme.spacing(3),
      },
      "& .MuiDataGrid-columnSeparator": {
        display: "none",
      },
      "& .MuiButton-label": {
        textTransform: "none",
        color: theme.palette.secondary.main,
      },
      "& .MuiTablePagination-root": {
        color: theme.palette.secondary.main,
      },
      "& .MuiDataGrid-cell": {
        display: "block !important",
        width: "100%",
      },
      "& .MuiDataGrid-toolbarContainer": {
        backgroundColor: "transparent",
        marginBottom: 10,
        "& .MuiButton-label": {
          color: theme.palette.type === "dark" ? theme.palette.grey[300] : theme.palette.grey[700],
        },
        "& .MuiSvgIcon-root": {
          color: theme.palette.secondary.main,
        },
      },
      "& .MuiDataGrid-columnHeaderTitle": {
        fontSize: 14,
        fontWeight: "normal",
        textAlign: "left",
      },
      "& .MuiDataGrid-selectedRowCount": {
        color: "transparent",
      },
      "& .MuiDataGrid-columnHeaderTitleContainer": {
        paddingLeft: 0,
        paddingRight: 0,
      },
      "& .MuiDataGrid-booleanCell[data-value='true']": {
        color: theme.palette.success.dark,
      },
      "& .MuiDataGrid-booleanCell[data-value='false']": {
        color: theme.palette.error.light,
        opacity: 0.7,
      },
      "& .editColumn": {
        backgroundColor: alpha(theme.palette.secondary.dark, 0.1),
      },
    },
    bottomSpacer: {
      marginBottom: theme.spacing(2),
    },
    formControl: {
      margin: theme.spacing(0),
      minWidth: 120,
    },
    avatar: {
      backgroundColor: theme.palette.type === "dark" ? "transparent" : "transparent",
    },
    avatarAlt: {
      width: "60px",
      height: "60px",
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[900] : theme.palette.grey[100],
      borderRadius: 4,
    },
    toggleFontColor: {
      color: theme.palette.type === "dark" ? theme.palette.grey[400] : theme.palette.grey[600],
    },
    bold: {
      fontWeight: "bold",
    },
    bolder: {
      fontWeight: "bolder",
    },
    errorText: {
      color: theme.palette.error.main,
      fontSize: "0.9em",
      marginTop: "3px",
      fontWeight: 400
    },
    successText: {
      color: "#5FB863",
      fontSize: "0.9em",
      marginTop: "3px",
      fontWeight: 400
    },
    warningText: {
      color: "#FFA727",
      fontSize: "0.9em",
      marginTop: "3px",
      fontWeight: 400
    },
    success: {
      color: "#5FB863",
      marginTop: "3px",
    },
    error: {
      color: "#FFA727",
      marginTop: "3px",
    },
    rightCardContainer: {
      animation: "slideFromDown 1s forwards",
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[900] : theme.palette.grey[50],
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[300],
      paddingBottom: "5px",
      transition: "all 0.3s ease-in-out 0s",
      opacity: 0.8,
      "& .MuiCardHeader-root": {
        fontStyle: "italic",
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
        borderBottomColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.grey[300],
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : "#e6eaf0",
      },
      "& .MuiCardHeader-subheader": {
        fontWeight: "bold",
        fontSize: "14px",
        color: theme.palette.type === "dark" ? theme.palette.grey[200] : theme.palette.grey[900],
      },
      "& .MuiIconButton-root": {
        padding: "3px",
      },
      "& .MuiTypography-caption": {
        color: theme.palette.type === "dark" ? theme.palette.grey[200] : theme.palette.grey[800],
      },
      "& .count": {
        color: theme.palette.type === "dark" ? "#a28fcb" : "#AC4A69",
      },
      "& .text": {
        fontSize: '18px',
        color: theme.palette.type === "dark" ? "#a28fcb" : "#AC4A69",
      },
    },
    topic: {
      fontStyle: "italic",
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[900] : "#F9F9F9",
      borderLeftWidth: 6,
      borderLeftColor: theme.palette.type === "dark" ? theme.palette.primary.main : theme.palette.primary.light,
      borderLeftStyle: "outset",
      fontSize: 18,
      color: theme.palette.type === "dark" ? theme.palette.grey[500] : theme.palette.grey[800],
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(3),
      textTransform: "uppercase",
      height: "40px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "& .MuiIconButton-root": {
        padding: "0px",
      },
      "& .MuiIconButton-colorSecondary": {
        color: theme.palette.type === "dark" ? theme.palette.grey[200] : '',
      },
      "& .MuiSvgIcon-colorSecondary": {
        color: theme.palette.type === "dark" ? theme.palette.grey[200] : '',
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
      },
    },
    ellipsis: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    dialogTitleContainer: {
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.secondary.main,
      color: theme.palette.type === "dark" ? "#ffffff" : theme.palette.secondary.contrastText,

      [theme.breakpoints.up("sm")]: {
        // clipPath: "polygon(0 0, 100% 0%, 100% 60%, 0% 100%)",
      },
    },
    link: {
      cursor: "pointer",
    },
    buttonDefault: {
      marginLeft: "4px",
      marginRight: "4px",
      minWidth: "55px",
      [theme.breakpoints.down("xs")]: {
        fontSize: 12,
      },
    },
  })
);

export default GlobalStyles;
